
import { defineComponent } from "vue";
import IntegerControl from "@/components/controls/base/IntegerControl.vue";

export default defineComponent({
  components: {
    IntegerControl,
  },
  props: {
    model: { required: true },
  },
  created(){
    this.modelLocal = this.model;
  },
  methods: {},
  data(){
    return {
      modelLocal: null,
      weight: [{name: "cabinAxle", top: 325, left: 50},
        {name: "tractorFirstAxle", top: 325, left: 255}, 
        {name: "tractorSecondAxle", top: 325, left: 350}, 
        {name: "semitrailerFirstAxle", top: 325, left: 575},
        {name: "semitrailerSecondAxle", top: 325, left: 645},
        {name: "semitrailerThirdAxle", top: 325, left: 715}],
      distance: [{name: "tractorAxlesDistanceFirst", top: 142, left: 170, width: 38},
        {name: "tractorAxlesDistanceSecond", top: 142, left: 219, width: 56},
        {name: "tractorAxlesDistanceThird", top: 142, left: 305, width: 56},
        {name: "semitrailerAxlesDistanceFirst", top: 142, left: 679, width: 56},
        {name: "tractorCabinAxlesDistance", top: 273, left: 155, width: 56},
        {name: "tractorSemitrailerAxlesDistance", top: 106, left: 415, width: 56}],
    };
  },
});
